const $$splitComponentImporter = () => import('/src/src/routes/_authenticated/_feature_announcement/_user/events/drafts/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { defineMessage } from "react-intl";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";
export const Route = createFileRoute("/_authenticated/_feature_announcement/_user/events/drafts/")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: zodValidator(z.object({
    postTo: z.string().uuid().optional()
  })),
  staticData: {
    pageTitle: defineMessage({
      defaultMessage: "Event Drafts",
      description: "Page title for the event drafts path"
    })
  }
});